import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyMedicalReviewServices = {
  //Medical Review Settings
  saveMedicalReviewSettings,
  getMedicalReviewSettings,

  //Subject Medical Review
  saveSubjectMedicalReview,
  getSubjectMedicalReview,
  getSubjectMedicalReviewStatus,
  sendSubjectForMedicalReview,
  getSubjectMedicalReviewTask,
  getSubjectMedicalReviewTaskStatus,
  getSingleSubjectMedicalReviewer,
  completeTaskSubjectForMedicalReview,
  getTaskManagementAnalytics,
  getCompletionByMedicalReviewForm,
  getMedicalTaskReviewerPerformance,
  completeBulkTaskSubjectForMedicalReview,

  //Comment
  addNewStudySubjectMedicalReviewComment,
  closedStudySubjectMedicalReviewComment,
  getStudySubjectMedicalReviewComments,
};

// Add New Study Subject Medical Review Comment
async function addNewStudySubjectMedicalReviewComment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectMedicalReviewComment`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Cloase Study Subject Medical Review Comment
async function closedStudySubjectMedicalReviewComment(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}closedStudySubjectMedicalReviewComment`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Subject Medical Review Comments
async function getStudySubjectMedicalReviewComments(studyId, siteId, reviewId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectMedicalReviewComments/${studyId}/${siteId}/${reviewId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Save Medical Review Settings
async function saveMedicalReviewSettings(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}saveMedicalReviewSettings`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Medical Review Settings
async function getMedicalReviewSettings(studyId, schemaId, eventId, timePointId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getMedicalReviewSettings/${studyId}/${schemaId}/${eventId}/${timePointId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Save Subject Medical Review
async function saveSubjectMedicalReview(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}saveSubjectMedicalReview`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Complete Bulk Task Subject For Medical Review
async function completeBulkTaskSubjectForMedicalReview(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}completeBulkTaskSubjectForMedicalReview`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Complete Task Subject For Medical Review
async function completeTaskSubjectForMedicalReview(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}completeTaskSubjectForMedicalReview`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Send Subject For Medical Review
async function sendSubjectForMedicalReview(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendSubjectForMedicalReview`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Subject Medical Review
async function getSubjectMedicalReview(studyId, siteId, subjectId, schemaId, eventId, timePointId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSubjectMedicalReview/${studyId}/${siteId}/${subjectId}/${schemaId}/${eventId}/${timePointId || "no"}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Subject Medical Review Status
async function getSubjectMedicalReviewStatus(studyId, siteId, subjectId, schemaId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSubjectMedicalReviewStatus/${studyId}/${siteId}/${subjectId}/${schemaId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Subject Medical Review Task
async function getSubjectMedicalReviewTask(studyId, category, status, type, dataType, mode, siteId, subjectId, formId, eventId, timePointId, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSubjectMedicalReviewTask/${studyId}/${category}/${status}/${type}/${dataType}/${mode}?siteId=${siteId || ""}&subjectId=${subjectId || ""}&formId=${formId || ""}&eventId=${eventId || ""}&timePointId=${timePointId || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSubjectMedicalReviewTask/${studyId}/${category}/${status}/${type}/${dataType}/${mode}?siteId=${siteId || ""}&subjectId=${subjectId || ""}&formId=${formId || ""}&eventId=${eventId || ""}&timePointId=${timePointId || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Subject Medical Review Task Status
async function getSubjectMedicalReviewTaskStatus(studyId, category, type, dataType, mode, siteId, subjectId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSubjectMedicalReviewTaskStatus/${studyId}/${category}/${type}/${dataType}/${mode}?siteId=${siteId || ""}&subjectId=${subjectId || ""}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Single Subject Medical Reviewer
async function getSingleSubjectMedicalReviewer(studyId, siteId, subjectId, schemaId, formId, eventId, timePointId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSingleSubjectMedicalReviewer/${studyId}/${siteId}/${subjectId}/${schemaId}/${formId}/${eventId}/${timePointId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Task Management Analytics
async function getTaskManagementAnalytics(studyId, type, dataType, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTaskManagementAnalytics/${studyId}/${type}/${dataType}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Completion By Medical Review Form
async function getCompletionByMedicalReviewForm(studyId, type, dataType, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getCompletionByMedicalReviewForm/${studyId}/${type}/${dataType}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Medical Task Reviewer Performance
async function getMedicalTaskReviewerPerformance(studyId, type, dataType, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getMedicalTaskReviewerPerformance/${studyId}/${type}/${dataType}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}